import { asyncRoutes, constantRoutes } from '@/router/_router'
import cost from '@/menus/cost/cost';
import report from '@/menus/report/report';
import other from '@/menus/other/other';
import inventory from '@/menus/inventory/inventory';
import setting from '@/menus/setting/setting';
const Layout = () => import (`@/page/index/index.vue`);
const PubIndex = () => import (`@/views/pub/pubIndex.vue`);
import { validatenull } from "@/util/validate";
import router from "@/router/router";
import store from "../index";

let newMenusArray = [...cost, ...other, ...inventory, ...report, ...setting];

/**
 * 判断是否有权限
 * @param pers 登录返回的所有权限
 * @param route 路由
 * @returns {*}
 */
function hasPermission(pers, route) {
  if (route.permission) {
    return pers.some(per => per == route.permission)
  } else {
    return true
  }
}

/**
 *
 * @param routes 过滤出有权限的路由
 * @param pers
 * @param isParent 是否是第一级，菜单中没有component属性的路由，第一级渲染Layout,其余的如果path为.action的渲染PubIndex，否则渲染为router-view
 * @returns {Array}
 */
export function filterAsyncRoutes(routes, pers, isParent = true) {
  const res = []
  routes.forEach(route => {
    let tmp = { ...route }
    if (hasPermission(pers, tmp)) {
      if (validatenull(route.component)) {
        if (isParent) {
          tmp.component = Layout;
        } else if (tmp.path.includes('.action')) {
          tmp.component = PubIndex;
        } else {
          tmp = {
            ...tmp,
            component: { render: h => h("router-view") }
          }
        }
      }
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, pers, false)
      }
      res.push(tmp)
    }
  })
  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(asyncRoutes).concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, pers) {
    return new Promise(resolve => {
      const accessedRoutes = filterAsyncRoutes(newMenusArray, pers)
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },
  addGenerateRoutes({ commit, dispatch }) {
    const menuSet = store.getters.pms[0];
    dispatch('generateRoutes', menuSet).then(accessRoutes => {
      const routes = [
        ...accessRoutes,
        {
          path: '*',
          redirect: '/404',
          hidden: true
        }
      ]
      router.addRoutes(routes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
